var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37695 7.875C5.0289 7.875 5.59019 7.96623 6.07129 8.12012C4.97152 8.96938 4.37695 10.189 4.37695 11.375C4.37695 11.7067 4.44321 12.0014 4.56641 12.25H0.876953C0.876953 12.25 0.00195312 12.25 0.00195312 11.375C0.00195336 10.5 0.876954 7.875 4.37695 7.875ZM9.62695 7.875C13.1269 7.87502 14.002 10.5 14.002 11.375C14.002 12.2467 13.1335 12.25 13.127 12.25H6.12695C6.12695 12.25 5.25195 12.25 5.25195 11.375C5.25195 10.5 6.12695 7.875 9.62695 7.875ZM3.93945 2.625C5.14756 2.62502 6.12695 3.60439 6.12695 4.8125C6.12695 6.02061 5.14756 6.99998 3.93945 7C2.73133 7 1.75195 6.02062 1.75195 4.8125C1.75195 3.60438 2.73133 2.625 3.93945 2.625ZM9.62695 1.75C11.0767 1.75002 12.252 2.92527 12.252 4.375C12.252 5.82473 11.0767 6.99998 9.62695 7C8.17721 7 7.00195 5.82475 7.00195 4.375C7.00195 2.92525 8.17721 1.75 9.62695 1.75Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8fddce42c2562b5536de5c86fb68ab2f.svg";
export { ForwardRef as ReactComponent };